import { useState } from 'react'
import { SIGNUP_INTENT } from 'apps/fleet-planner/types'
import { useCarrierList } from './useCarrierList'
import { useIsEmbeddedInMobileApp } from './useIsEmbeddedInMobileApp'

/**
 * Stores state around actions in <OnboardingWizard />
 */
export const useOnboardingWizard = () => {
  const [userEmail, setUserEmail] = useState<string>()
  const [activeStep, setActiveStep] = useState<number>(1)
  const [selectedOptions, setSelectedOptions] = useState<SIGNUP_INTENT[]>([])
  const { carriers = [], addCarrier, removeCarrierByIndex } = useCarrierList()
  const mobileApp = useIsEmbeddedInMobileApp()

  return {
    activeStep,
    setActiveStep,
    userEmail,
    setUserEmail,
    carriers,
    addCarrier,
    removeCarrierByIndex,
    selectedOptions,
    setSelectedOptions,
    mobileApp,
  }
}
